import { Schema } from "nutso";

import { UserProfile } from "../models/UserProfile";

export const userProfileSchema: Schema<UserProfile, any, any> = {
  type: "object",
  properties: {
    uid: {
      type: "string",
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    profilePicture: {
      type: "object",
      optional: true,
      properties: {
        id: {
          type: "string",
        },
        path: {
          type: "string",
        },
      },
    },
  },
};
